import {Model} from '@/models/model';

const HUMAN_NAMES = {
    string: 'String',
    integer: 'Number',
    boolean: 'Boolean',
    map: 'Map',
    array: 'Array',
    any: 'Any',
};

class TypeDescriptor extends Model {
    describe(node) {
        const outputs = [];
        if (this.id === 'keysOf') {
            for (const entry of node.arguments[this.source]) {
                outputs.push({
                    id: entry[this.field],
                    name: entry[this.field],
                    description: `The value of '${entry[this.field]}'`,
                    type: Type.any(),
                });
            }
        }

        return outputs;
    }
}

/**
 * @property id
 * @property properties
 */
export class Type extends Model {
    cast_descriptor(rawDescriptor) {
        return new TypeDescriptor(rawDescriptor);
    }

    cast_properties(rawProperties) {
        return rawProperties.map(rawProperty => {
            rawProperty.type = new Type(rawProperty.type);

            return rawProperty;
        });
    }

    get humanName() {
        return HUMAN_NAMES[this.id] || this.id;
    }

    static integer() {
        return new Type({id: 'integer'});
    }

    static number() {
        return new Type({id: 'number'});
    }

    static string() {
        return new Type({id: 'string'});
    }

    static any() {
        return new Type({id: 'any'});
    }

    static boolean() {
        return new Type({id: 'boolean'});
    }

    static object(properties = {}) {
        return new Type({
            id: 'object',
            properties,
        });
    }

    static listOf(values = {}) {
        return new Type({
            id: 'list',
            properties: {values},
        });
    }
}
